import Sidebar from './Sidebar';
import Home from './Home';
import MetaData from '../../layouts/MetaData';
import ErrorBoundary from '../../layouts/ErrorBoundary';

const Dashboard = () => {
    return (
        <>
            <div className="admindashboardbody">
                <MetaData title="Dashboard" />
                <ErrorBoundary title="Sidebar"><Sidebar /></ErrorBoundary>
                <ErrorBoundary title="Dashboard"><Home /></ErrorBoundary>
            </div>
        </>
    )
}

export default Dashboard;
